import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            it: { translation: it },
            en: { translation: en },
            de: { translation: de },
            fr: { translation: fr },
            es: { translation: es },
        },
        fallbackLng: "it",
        supportedLngs: ["it", "en", "de", "fr", "es"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "renova_lang",
            caches: ["localStorage"],
        },
    });

export default i18n;
